module.exports = __webpack_public_path__ + "img/gisela-robert.3f11936d.jpg";